import { render, staticRenderFns } from "./classify-sub-add.vue?vue&type=template&id=0075fe6d&scoped=true&"
import script from "./classify-sub-add.vue?vue&type=script&lang=js&"
export * from "./classify-sub-add.vue?vue&type=script&lang=js&"
import style0 from "./classify-sub-add.vue?vue&type=style&index=0&id=0075fe6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075fe6d",
  null
  
)

export default component.exports